import { style } from '@vanilla-extract/css'
import { mainWrapper as SettingMainWrapper } from '~/components/Scopes/Settings/Setting.css'
import { inputField as invoiceLinesInputField } from '~/domains/finance/components/InvoiceModal.css'
import { vars } from '~/styles/theme.css'
import { fieldset, formClassLarge } from '../Form.css'

export const inputWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  minWidth: 0
})

export const inputHasLeadingText = style({})

export const inputHasTrailingText = style({})

export const inputHasCurrencyDropdown = style({})

export const inputHasTrailingDropdown = style({})

export const inputLabel = style({
  color: vars.color.dark,
  fontSize: vars.font.label.size,
  fontWeight: vars.font.label.weight,
  width: '100%', // Override v2 legacy style
  textAlign: 'left', // Override v2 legacy style
  height: 'auto', // Override v2 legacy style
  float: 'none', // Override v2 legacy style
  padding: 0, // Override v2 legacy style
  margin: 0, // Override v2 legacy style
  cursor: 'pointer'
})

export const inputLabelSmall = style({
  fontSize: vars.font.smallNormal.size
})

export const inputField = style({
  backgroundColor: vars.color.mainHover,
  borderRadius: vars.buttons.radius,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  width: '100%',

  selectors: {
    [`${formClassLarge} &`]: {
      backgroundColor: vars.color.drawBackgroundLighter,
      border: `1px solid ${vars.color.mainHover}`
    },
    [`${SettingMainWrapper} &:has(input[type="number"])`]: {
      // Limit the width of the input in the Setting component
      width: 150
    },
    [`${fieldset} &`]: {
      backgroundColor: vars.color.white,
      border: `1px solid ${vars.color.mediumLighter}`
    }
  }
})

export const halfWidth = style({
  maxWidth: '50%'
})

const inputProps = {
  flex: 1,
  height: 48,
  width: '100%',
  padding: '0 16px',
  backgroundColor: 'transparent',
  color: vars.color.dark,
  borderRadius: vars.buttons.radius,
  border: 'none',
  fontSize: vars.font.input.size,
  fontWeight: vars.font.input.weight
}

export const input = style({
  ...inputProps,
  outlineColor: vars.font.input.borderColor,

  '::placeholder': {
    color: vars.color.medium
  },

  ':invalid': {
    backgroundColor: 'transparent' // Override v2 legacy style
  },

  selectors: {
    [`${inputHasCurrencyDropdown} &[type="number"], ${inputHasCurrencyDropdown} &[type="text"], ${inputHasCurrencyDropdown} &[type="email"], ${inputHasCurrencyDropdown} &[type="password"], ${inputHasCurrencyDropdown} &[type="time"], ${inputHasCurrencyDropdown} &[type="date"], ${inputHasCurrencyDropdown} &[type="tel"], ${inputHasTrailingDropdown} &[type="number"], ${inputHasTrailingDropdown} &[type="text"], ${inputHasTrailingDropdown} &[type="email"], ${inputHasTrailingDropdown} &[type="password"], ${inputHasTrailingDropdown} &[type="time"], ${inputHasTrailingDropdown} &[type="date"], ${inputHasTrailingDropdown} &[type="tel"]`]:
      {
        paddingRight: 8
      },
    [`${inputHasLeadingText} &[type="number"], ${inputHasLeadingText} &[type="text"], ${inputHasLeadingText} &[type="email"], ${inputHasLeadingText} &[type="password"], ${inputHasLeadingText} &[type="time"], ${inputHasLeadingText} &[type="date"], ${inputHasLeadingText} &[type="tel"]`]:
      {
        paddingLeft: 8
      },
    [`${inputHasTrailingText} &[type="number"], ${inputHasTrailingText} &[type="text"], ${inputHasTrailingText} &[type="email"], ${inputHasTrailingText} &[type="password"], ${inputHasTrailingText} &[type="time"], ${inputHasTrailingText} &[type="date"], ${inputHasTrailingText} &[type="tel"]`]:
      {
        paddingRight: 8
      },
    [`${invoiceLinesInputField} &[type="number"], ${invoiceLinesInputField} &[type="text"], ${invoiceLinesInputField} &[type="email"], ${invoiceLinesInputField} &[type="password"], ${invoiceLinesInputField} &[type="time"], ${invoiceLinesInputField} &[type="date"], ${invoiceLinesInputField} &[type="tel"]`]:
      {
        height: 32
      },
    [`${invoiceLinesInputField} &[type="text"]`]: {
      minWidth: 200
    },
    // Override v2 legacy style
    '&[type="number"], &[type="text"], &[type="email"], &[type="password"], &[type="time"], &[type="date"], &[type="tel"]':
      {
        ...inputProps,
        margin: 0,
        float: 'none'
      },
    '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button':
      {
        appearance: 'none',
        margin: 0
      }
  }
})

export const textarea = style({
  padding: 11,
  width: '100%',
  minHeight: 150,
  resize: 'vertical',
  backgroundColor: vars.color.mainHover,
  borderRadius: vars.blocks.radius,
  border: `1px solid ${vars.color.drawBackground}`,
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  outlineColor: vars.font.input.borderColor,

  '::placeholder': {
    color: vars.color.medium
  },

  ':invalid': {
    backgroundColor: 'transparent' // Override v2 legacy style
  },

  selectors: {
    [`${formClassLarge} &`]: {
      backgroundColor: vars.color.drawBackgroundLighter
    }
  }
})

export const textareaAutoResize = style({
  minHeight: 0,
  resize: 'none',
  overflow: 'hidden'
})

export const textareaInfoTrigger = style({
  position: 'absolute',
  right: 6,
  bottom: 6,
  zIndex: 1,
  cursor: 'pointer',
  color: vars.color.medium
})

export const textareaInfo = style({
  position: 'absolute',
  right: 6,
  bottom: 6,
  padding: 8,
  backgroundColor: vars.color.drawBackgroundLighter,
  color: vars.color.dark,
  borderRadius: vars.blocks.radius,
  boxShadow: vars.shadow,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  zIndex: 2,
  maxWidth: 200
})

export const textareaInfoHeader = style({
  display: 'flex',
  gap: 5,
  alignItems: 'center',
  fontWeight: vars.font.smallBold.weight,
  marginBottom: 4
})

export const inputSmall = style({
  height: 36,
  selectors: {
    '&&': {
      height: 36
    }
  }
})

export const inputExtraSmall = style({
  selectors: {
    '&&': {
      height: 29,
      fontSize: '0.9em',
      padding: '0 8px'
    }
  }
})

export const inputPassword = style({
  paddingRight: 60
})

export const inputDate = style({
  width: 100,
  padding: '0 2px',
  fontSize: vars.font.input.icon
})

export const inputError = style({
  border: `2px solid ${vars.color.danger}`,
  backgroundColor: vars.color.dangerLighter
})

export const inputLeadingIcon = style({
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  color: vars.color.dark,
  fontSize: vars.font.input.icon
})

export const inputTrailingIcon = style({
  position: 'absolute',
  right: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  color: vars.color.dark,
  fontSize: vars.font.input.icon
})

export const inputTrailingIconClickable = style({
  cursor: 'pointer',
  pointerEvents: 'none'
})

export const inputLeadingText = style({
  color: vars.color.dark,
  fontSize: vars.font.subcontent.size,
  fontWeight: vars.font.subcontent.weight,
  whiteSpace: 'nowrap',
  marginLeft: 8,
  selectors: {
    [`${inputExtraSmall} &`]: {
      fontSize: vars.font.smallNormal.size,
      fontWeight: vars.font.smallNormal.weight
    }
  }
})

export const inputTrailingText = style({
  color: vars.color.dark,
  fontSize: 14,
  fontWeight: 600,
  whiteSpace: 'nowrap',
  marginRight: 8
})

export const inputHasLeadingIcon = style({
  paddingLeft: 32,
  selectors: {
    '&&': {
      // Override v2 legacy style
      paddingLeft: 32
    }
  }
})

export const inputHasTrailingIcon = style({
  paddingRight: 32,
  selectors: {
    '&&': {
      // Override v2 legacy style
      paddingRight: 32
    }
  }
})

export const inputDisabled = style({
  opacity: 0.5,
  cursor: 'not-allowed'
})

export const errorMessage = style({
  color: vars.color.danger,
  fontSize: 16,
  fontWeight: 500
})

export const passwordVisibilityTrigger = style({
  position: 'absolute',
  cursor: 'pointer',
  right: 0,
  top: '50%',
  borderLeft: `1px solid ${vars.color.dark}`,
  transform: 'translateY(-50%)',
  width: 55,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 19,
  color: vars.color.dark
})

export const passwordVisibilityTriggerOnError = style({
  borderLeft: `1px solid ${vars.color.danger}`,
  color: vars.color.danger
})
